import { IconType } from "react-icons";
import { GrChannel } from "react-icons/gr";
import { TiSocialDribbble } from "react-icons/ti";
import { GoFileMedia } from "react-icons/go";
import { UserModuleNameTypes } from "./models/userAccess/UserAccess.model";

type NavItemTypeWithoutChild = {
    label: string;
    moduleName: string;
    path: string;
    icon: IconType;
    children?: never;
};

type NavItemTypeWithChild = {
    label: string;
    moduleName: string;
    path?: never;
    icon: IconType;
    children?: {
        label: string;
        moduleName: string;
        path: string;
        icon: IconType;
    }[];
};

export type NavItemType = NavItemTypeWithChild | NavItemTypeWithoutChild;

export const marketingNavigation: NavItemType[] = [
    {
        label: "Channel",
        icon: GrChannel,
        moduleName: UserModuleNameTypes.CHANNEL,
        path: "channel",
    },
    {
        label: "Campaign Group",
        icon: TiSocialDribbble,
        moduleName: UserModuleNameTypes.CAMPAIGN_GROUP,
        path: "campaign-group",
    },
    {
        label: "Campaign",
        icon: GoFileMedia,
        moduleName: UserModuleNameTypes.CAMPAIGN,
        path: "campaign",
    },
];
